/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
var React = require("react");
var IconSVG = /** @class */ (function (_super) {
    tslib_1.__extends(IconSVG, _super);
    function IconSVG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconSVG.prototype.render = function () {
        return (React.createElement("svg", tslib_1.__assign({ role: "img", viewBox: "0 0 16 16" }, this.props),
            React.createElement("path", { d: "m12.704 8c0 .42488775-.336.76972418-.75.76972418h-3.204v3.17434252c0 .4248878-.336.7697242-.75.7697242s-.75-.3448364-.75-.7697242v-3.17434252h-3.205c-.414 0-.75-.34483643-.75-.76972418s.336-.76972418.75-.76972418h3.205v-3.17434253c0-.42488775.336-.76972418.75-.76972418s.75.34483643.75.76972418v3.17434253h3.204c.414 0 .75.34483643.75.76972418m-4.704-8c4.411 0 8 3.58896729 8 8 0 4.4110327-3.589 8-8 8s-8-3.5889673-8-8c0-4.41103271 3.589-8 8-8zm0 14.4605516c3.584 0 6.5-2.8982681 6.5-6.4605516 0-3.56228352-2.916-6.46055164-6.5-6.46055164s-6.5 2.89826812-6.5 6.46055164c0 3.5622835 2.916 6.4605516 6.5 6.4605516z" })));
    };
    return IconSVG;
}(React.Component));
exports.IconSVG = IconSVG;